import { StateCreator } from 'zustand';

import { Api } from 'src/models/Api.model';
import { GalenDataUser } from 'src/models/GalenData/User.model';
import { Language } from 'src/models/Language.model';
import { Product } from 'src/models/Product.model';
import {
  PracticeSettings,
  Settings,
  UserSettings,
} from 'src/models/Settings.model';

import { RemoteBoundStoreState } from './useRemoteBoundStore';

type AuthStateTypes = {
  authInfo: { authToken: string; refreshToken: string };
};

export type CurrentUserStateTypes = {
  currentUser: GalenDataUser | undefined;
};

type StateTypes = AuthStateTypes & CurrentUserStateTypes & Settings;

type ActionsTypes = {
  setAuth: (auth: AuthStateTypes) => void;
  logOut: (reloadPage?: boolean) => void;
  setCurrentUser: (currentUser: CurrentUserStateTypes) => void;

  setUserSettings: (settings: { userSettings: UserSettings }) => void;

  setPracticeSettings: (settings: {
    practiceSettings: PracticeSettings;
  }) => void;

  setLanguage: (lng: Language) => void;
};

export type UserSliceTypes = StateTypes & ActionsTypes & Settings;

const initialState: StateTypes = {
  authInfo: {
    authToken: '',
    refreshToken: '',
  },
  currentUser: undefined,
  userSettings: {
    userPermission: {
      read: false,
      print: false,
      create: false,
      list: false,
      update: false,
    },
  },
  practiceSettings: {
    broadcast: '',
    product: Product.TELEOPHTH,
    hasMfa: false,
  },
};

export const createUserSlice: StateCreator<
  RemoteBoundStoreState,
  [],
  [],
  UserSliceTypes
> = (set, get) => {
  return {
    ...initialState,

    setAuth: (authInfo: AuthStateTypes) => {
      set(authInfo);
    },

    logOut: (reloadPage: boolean = false) => {
      set(initialState);
      Api.remote.logout(reloadPage);
    },
    setCurrentUser: (currentUser: CurrentUserStateTypes) => {
      set(currentUser);
    },
    setUserSettings(settings) {
      set(settings);
    },

    setPracticeSettings(settings) {
      set(settings);
    },

    setLanguage(lng) {
      const newPracticeSettings = { ...get().practiceSettings, language: lng };
      set({ practiceSettings: newPracticeSettings });
    },
  };
};
